function InputField(props) {
  const { 
    label, 
    id, 
    extra, 
    type, 
    placeholder, 
    variant, 
    state, 
    disabled,
    value,        // new: controlled value
    onChange,
    style,
    className
    
  } = props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-navy-700 dark:text-slate-200 ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {label}
      </label>
      <input
        disabled={disabled}
        type={type}
        id={id}
        style={style}
        placeholder={placeholder}
       value={type === "file" ? undefined : value}      // controlled value here
        onChange={onChange} // change handler here
         className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl 
          border bg-white p-3 text-sm outline-none
          ${disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-slate-800/50 dark:text-slate-400 dark:placeholder:!text-slate-600"
            : state === "error"
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400 dark:bg-slate-800/50"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400 dark:bg-slate-800/50"
            : "border-gray-200 dark:!border-slate-600 dark:bg-slate-800/50 dark:text-slate-100 dark:placeholder:text-slate-500"
          }
          ${className || ""}   // 👉 user class override
        `}
      />
    </div>
  );
}

export default InputField;
